import Link from 'next/link';
import React from 'react';
import StaticLayout from '../components/StaticLayout';
import { FaRegCheckCircle } from 'react-icons/fa';

const Pricing: React.FC = () => (
  <StaticLayout>
    <div className="container mx-auto h-full py-8">
      <header className="flex flex-col items-center my-8">
        <p className="text-xl md:text-6xl text-indigo-700 font-bold">
          Prices that fit your company's needs.
        </p>
        <p className="text-xl md:text-6xl text-indigo-400 font-bold">
          No hidden fees. No surprises.
        </p>
        <p className="text-lg md:text-2xl text-gray-500 font-bold my-6">
          30 days trial period with all features
        </p>
      </header>
      <section className="flex flex-col lg:flex-row items-center lg:justify-center w-full lg:px-10">
        <article className="bg-white lg:w-80 mb-16 lg:px-4 px-6 py-4 text-center text-primary-dark rounded-md border-indigo-50 border-2 -right-2 relative">
          <h5 className="font-bold text-xl my-4">Growth</h5>
          <div className="mb-2">
            <h2 className="font-bold text-6xl">Free</h2>
            <h3 className="text-xl text-gray-400">For up to 25 members</h3>
            <p className="text-xs mb-2 text-gray-400">Free. As in forever.</p>
            <p>The basics to get your started:</p>
          </div>
          <ul className="text-sm font-bold">
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Unlimited Topics & Ideas
              </div>
            </li>
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Slack & Zapier integrations
              </div>
            </li>
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Analytics
              </div>
            </li>
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Roadmap
              </div>
            </li>
          </ul>
          <div className="rounded-md shadow">
            <Link href="/register?plan=free">
              <a className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-indigo-50 hover:bg-indigo-100 md:py-4 md:text-lg md:px-10">
                Select
              </a>
            </Link>
          </div>
        </article>
        <article className="bg-indigo-700 border-indigo-50 border-2 lg:w-100 mb-10 px-8 py-8 lg:-mt-6 text-white text-center rounded-md z-10">
          <h5 className="font-bold text-xl my-4">Professional</h5>
          <h2 className="pb-2 font-bold">
            <span className="text-6xl">$5</span>
          </h2>
          <span className="text-2xl text-gray-300">per user/month</span>
          <p className="text-xs mb-2 text-gray-400">
            Billed yearly. $6/user billed monthly
          </p>
          <p>All from Growth plan, plus:</p>
          <ul className="text-sm font-bold">
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Unlimited members & guests
              </div>
            </li>
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Advanced Analytics
              </div>
            </li>
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Advanced Roles and Permissions
              </div>
            </li>
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Templates
              </div>
            </li>
          </ul>
          <div className="rounded-md shadow">
            <Link href="/register?plan=pro&trial=true">
              <a className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-100 md:py-4 md:text-lg md:px-10">
                Start your free trial
              </a>
            </Link>
          </div>
        </article>
        <article className="bg-white lg:w-80 mb-16 lg:px-4 px-6 py-4 text-center text-primary-dark rounded-md border-indigo-50 border-2 -left-2 relative">
          <h5 className="font-bold text-xl my-4">Enterprise</h5>
          <h2 className="pb-2 font-bold">
            <span className="text-6xl">Custom</span>
          </h2>
          <span className="text-2xl text-gray-400">to your needs</span>
          <p className="text-xs mb-2 text-gray-400"></p>
          <p>Everything included, plus:</p>
          <ul className="text-sm font-bold">
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Single Sign-On
              </div>
            </li>
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Custom branding
              </div>
            </li>
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Audit Log
              </div>
            </li>
            <li className="flex align-middle pt-4 pb-4">
              <div className="text-left ml-12 w-full">
                <svg
                  className="h-6 w-6 inline-block mr-1 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Priority support
              </div>
            </li>
          </ul>
          <div className="rounded-md shadow">
            <a
              className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-indigo-50 hover:bg-indigo-100 md:py-4 md:text-lg md:px-10"
              href="mailto:hello@lampant.com"
            >
              Contact us
            </a>
          </div>
        </article>
      </section>

      <div className="lg:my-4 flex items-center justify-center flex-wrap lg:space-x-12 space-x-4">
        <div className="flex items-center space-x-2">
          <span className="text-green-400">
            <FaRegCheckCircle />
          </span>{' '}
          <span className="text-sm font-medium">No credit card required</span>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-green-400">
            <FaRegCheckCircle />
          </span>{' '}
          <span className="text-sm font-medium">Full featured trial</span>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-green-400">
            <FaRegCheckCircle />
          </span>{' '}
          <span className="text-sm font-medium">Cancel anytime</span>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-green-400">
            <FaRegCheckCircle />
          </span>{' '}
          <span className="text-sm font-medium">No hidden fees</span>
        </div>
      </div>

      <div className="mt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-xl text-indigo-600 font-semibold tracking-wide uppercase">
              FAQ
            </h2>
          </div>

          <div className="mt-10">
            <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
              <div className="flex">
                <div className="ml-4">
                  <dt className="text-lg leading-6 font-medium text-gray-900">
                    What happens when my trial is over?
                  </dt>
                  <dd className="mt-2 text-base text-gray-500">
                    We will let you know when your trial is about to end. You
                    will have the option to upgrade to the paid version or, if
                    you have less than 25 users, be downgraded to the Growth
                    plan. If you are above 25 uers, we will give you some time
                    to consider your options.
                  </dd>
                </div>
              </div>

              <div className="flex">
                <div className="ml-4">
                  <dt className="text-lg leading-6 font-medium text-gray-900">
                    How am I billed?
                  </dt>
                  <dd className="mt-2 text-base text-gray-500">
                    For monthly billing: when your trial ends, you get charged
                    for all active users. Every month after you pay for the
                    number of active users at the beginning of the month.
                  </dd>
                  <dd className="mt-2 text-base text-gray-500">
                    For yearly billing: when your trial ends, you get charged
                    for all active users. For every new user that is added, you
                    pay 1 full year pricing.
                  </dd>
                </div>
              </div>

              <div className="flex">
                <div className="ml-4">
                  <dt className="text-lg leading-6 font-medium text-gray-900">
                    I want to cancel my subscription. Can I get a refund?
                  </dt>
                  <dd className="mt-2 text-base text-gray-500">
                    No. We don't offer refunds for cancelled subscriptions.
                  </dd>
                </div>
              </div>

              <div className="flex">
                <div className="ml-4">
                  <dt className="text-lg leading-6 font-medium text-gray-900">
                    What features are available during my trial?
                  </dt>
                  <dd className="mt-2 text-base text-gray-500">
                    During the trial you will have access to all features in the
                    platform.
                  </dd>
                </div>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </StaticLayout>
);

export default Pricing;
